import React from 'react';
import { Form, Input, InputNumber, Select, Typography } from 'antd';
import DrawerForm from 'components/DrawerForm';
import { permissionOptions } from 'shared/utils/checkPermission';

const { Text } = Typography;

const dynamicContentOptions = [
  { value: '', label: 'None' },
  { value: 'MATOMO_GOALS', label: 'Matomo goals (one entry per goal)' },
];

function getDynamicContentDisabledReason(dashboard) {
  if (!dashboard?.parent) return 'Only available for child dashboards.';
  return null;
}

const EditDashboardDrawer = ({
  open,
  dashboard,
  canEditParent,
  parentOptions,
  isSuperUser,
  onCancel,
  onSubmit,
  onRemove,
}) => {
  const dynamicContentDisabledReason = getDynamicContentDisabledReason(dashboard);

  const initialValues = {
    title: dashboard?.title,
    parent: dashboard?.parent,
    dynamicContent: dashboard?.settings?.dynamicContent || '',
    sortIndex: dashboard?.settings?.sortIndex,
    viewPermission: dashboard?.settings?.viewPermission || '',
  };

  return (
    <DrawerForm
      title="Dashboard settings"
      open={open}
      onCancel={onCancel}
      onSubmit={onSubmit}
      onRemove={onRemove}
      initialValues={initialValues}
      formReset={dashboard?.id}
      removeLabel="dashboard"
    >
      <Form.Item name="title" label="Title" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="sortIndex" label="Sort index" tooltip="Lower numbers appear first. Leave empty to sort last.">
        <InputNumber min={0} style={{ width: '100%' }} />
      </Form.Item>
      {canEditParent && (
        <Form.Item
          name="parent"
          label="Parent dashboard"
        >
          <Select
            allowClear
            options={parentOptions}
            placeholder="Parent dashboard"
          />
        </Form.Item>
      )}
      <Form.Item
        name="dynamicContent"
        label="Use as template for"
        extra={dynamicContentDisabledReason && <Text type="secondary">{dynamicContentDisabledReason}</Text>}
      >
        <Select disabled={dynamicContentDisabledReason} options={dynamicContentOptions} />
      </Form.Item>
      {isSuperUser && (
        <Form.Item
          name="viewPermission"
          label="Required permission"
          tooltip="Users without this permission will not see this dashboard in the navigation."
        >
          <Select allowClear options={permissionOptions} />
        </Form.Item>
      )}
    </DrawerForm>
  );
};

export default EditDashboardDrawer;
